/* global $ */
/*function dbg(s, title) {
    "use strict";
    if (window.console && window.console.log) {
        if (title !== undefined) { console.log(title + ':'); }
        console.log(s);
    }
}

function log(s) {
    dbg(s + ' : ' + ((Math.random()*10)|0) )
}*/

function elem(id) { return document.getElementById(id) }

import cfg from './appconfig.js'

// *** polyfills ***
// load promise-polyfill
import Promise from 'promise-polyfill';
if (!window.Promise) {
    window.Promise = Promise;
}

// Array.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(searchElement, fromIndex) {

            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

// String.includes
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

// *** end of polyfills

//const dataUrl = '/static/domains-data.json'
//const dataUrl = '/static/domains-data1.json'

import Vue from 'vue'
import axios from 'axios'
import VSelectMy from './select.vue'


import i18n from 'vue-i18n'
Vue.use(i18n)
// set lang
Vue.config.lang = 'en'
import translations from './lang-data'
// set locales
Object.keys(translations).forEach(function (lang) {
    Vue.locale(lang, translations[lang])
})

import Materials from "vue-materials"
Vue.use(Materials)

function isValidEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function InitApp(exports, domains_data) {
    exports.app = new Vue({
        el: '#vueapp',
        components: { VSelectMy },
        data: {
            domainsData: domains_data,
            domain: 'main',
            lang: 'en',
            page: false,
            contact_tag: false,
            form_name: '',
            form_email: '',
            form_message: '',
            isMapEnabled: false,
            mapUrl: null,
            sent: false
        },
        filters: {
            capitalize: (s) => (s[0].toUpperCase() + s.slice(1))
            //pluralize: (n) => (n === 1 ? 'item' : 'items')
        },
        computed: {
            /*langItems: function () {
                return this.page.languages.map((v) => ({id: v, text: v}))
            },*/
            domainItems: function () {
                return this.domainsData.map((v) => ({id: v.domain, text: v.name}))
            },
            contactItems: function () {
                if (!this.page.contacts) {
                    return [];
                }
                return this.page.contacts.map((v) => ({id: v.tag, text: (v.name[this.lang] || v.name.en) }));
            },
            form_is_valid: function () {
                const v = this.form_name.length > 0 &&
                    isValidEmail(this.form_email) &&
                    this.form_message.length > 0
                return v;
            }
        },
        methods: {
            curHash: function (dom, lang) {
                return '#/' + dom + '/' + lang
            },
            /*selectContact: function (contact) {
                this.contact_tag = contact.tag
            },*/
            selectLanguage(domLangs ,lang) {
                const nav = window.navigator
                const a = [].concat(lang, nav.languages, nav.language, nav.userLanguage)
                let aa = []
                a.forEach( (v)=>{
                    if(!v) { return }
                    aa.push(v)
                    if (v.includes('-')) { aa.push(v.split('-')[0])}
                })
                //dbg(aa)
                const res = aa.filter((v)=>domLangs.includes(v))
                //dbg(res);
                if (res.length) { return res[0]; }
                return 'en'
            },
            selectDomain: function (dom, lang) {
                const t = this.domainsData.filter((v) => (v.domain === dom))
                const page = this.page = (t.length) ? t[0] : this.domainsData[0];
                this.domain = page.domain
                document.title = page.name
                this.contact_tag = page.contacts[0].tag
                Vue.config.lang = this.lang = this.selectLanguage(page.languages, lang)
                this.isMapEnabled = !!(page.map_url)
                if (page.map_url) {
                    this.mapUrl = page.map_url
                }
            },
            sendForm: function () {
                const form = elem('id_form');
                const data = new FormData(form)
                const config = {
                    // onUploadProgress: function(progressEvent) {
                    //     const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    //     dbg(percentCompleted)
                    // }
                };
                axios.post(cfg.postUrl, data, config)
                    .then( (res) => {
                        this.sent = true
                    })
                    .catch( (ignore) => { /*dbg(error,'error')*/ });
            },
            domainChanged() {
                //dbg('domainChanged:'+this.domain)
                window.location.hash = this.curHash(this.domain, this.lang)
            }
        },
        // created: function () {
        //     this.$on('input', function() { console.log('input'); });
        // },
        // updated: function () {
        //     checkSelectDropdown()
        //     log('updated(): done')
        // }
    });
}

function onHashChange () {
    const loc = window.location
    //dbg(loc)
    let p;
    if (loc.hash) {
        p = loc.hash.replace(/#\/?/, '').split('/')
    } else {
        p = loc.pathname.split('/').slice(1)
    }
    //dbg(p)
    app.selectDomain.apply(app, p)
}
window.addEventListener('hashchange', onHashChange)

// function checkSelectDropdown() {
//     if (!$('.select-dropdown').length) {
//         dbg('!!! - no dropdown!')
//     }
// }

$(document).ready(function () {
    axios.get(cfg.dataUrl)
        .then( (res) => {
            // console.log(res.data)
            InitApp(window, res.data)
            onHashChange()
        }).catch((res) => { /*console.log(res)*/ });
})



// WEBPACK FOOTER //
// ./src/main.js